/* src/app/features/habilitacao/patrimonio-liquido/novo-patrimonio-liquido/novo-patrimonio-liquido.component.scss */
/*# sourceMappingURL=novo-patrimonio-liquido.component.css.map */
